import { z } from "zod"
import {
  type Column,
  DEFAULT_COLUMNS,
} from "@/routes/_layout/work-orders/-lib/columns"
import { workOrderFilterConfigs } from "@/routes/_layout/work-orders/-lib/filters"
import {
  type WorkOrdersSearch,
  workOrdersSearchSchema,
} from "@/routes/_layout/work-orders/-lib/search"

const fields = workOrdersSearchSchema.shape

export const AIRCRAFT_WORK_ORDER_COLUMNS: Column[] = DEFAULT_COLUMNS.filter(
  (column) => column !== "asset" && column !== "serial",
)

export const workOrderSearchFields = {
  wo_search: fields.search,
  wo_status: fields.status,
  wo_priority: fields.priority,
  wo_subscribed: fields.subscribed,
  wo_customer: fields.customer,
  wo_group: fields.group,
  wo_subgroup: fields.subgroup,
  wo_columns: fields.columns,
  wo_sort: fields.sort,
  wo_direction: fields.direction,
}

const workOrderTabSearchSchema = z.object(workOrderSearchFields)

export type WorkOrderTabSearch = z.infer<typeof workOrderTabSearchSchema>

export const aircraftWorkOrderFilterConfigs = workOrderFilterConfigs.filter(
  (config) => config.key !== "kind",
)

export function workOrdersSearchOf(
  search: WorkOrderTabSearch,
): WorkOrdersSearch {
  return {
    search: search.wo_search,
    status: search.wo_status,
    priority: search.wo_priority,
    subscribed: search.wo_subscribed,
    customer: search.wo_customer,
    group: search.wo_group,
    subgroup: search.wo_subgroup,
    columns: search.wo_columns ?? AIRCRAFT_WORK_ORDER_COLUMNS,
    sort: search.wo_sort,
    direction: search.wo_direction,
  }
}

export function workOrderTabPatch(
  patch: Partial<WorkOrdersSearch>,
): Partial<WorkOrderTabSearch> {
  return {
    ...("search" in patch ? { wo_search: patch.search } : {}),
    ...("status" in patch ? { wo_status: patch.status } : {}),
    ...("priority" in patch ? { wo_priority: patch.priority } : {}),
    ...("subscribed" in patch ? { wo_subscribed: patch.subscribed } : {}),
    ...("customer" in patch ? { wo_customer: patch.customer } : {}),
    ...("group" in patch ? { wo_group: patch.group } : {}),
    ...("subgroup" in patch ? { wo_subgroup: patch.subgroup } : {}),
    ...("columns" in patch ? { wo_columns: patch.columns } : {}),
    ...("sort" in patch ? { wo_sort: patch.sort } : {}),
    ...("direction" in patch ? { wo_direction: patch.direction } : {}),
  }
}
